// src/api.js
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/v1/api';

const ADMIN_TOKEN_KEY = 'elite_admin_token';

export const setAdminToken = (token) => {
  if (token) {
    localStorage.setItem(ADMIN_TOKEN_KEY, token);
  }
};

export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_KEY);

export const clearAdminToken = () => {
  localStorage.removeItem(ADMIN_TOKEN_KEY);
};

export const getAdminAuthHeaders = () => {
  const token = getAdminToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const isAdminAuthenticated = () => Boolean(getAdminToken());

export const handleAdminAuthError = (error, navigate) => {
  if (error?.response?.status === 401) {
    clearAdminToken();
    navigate('/login', { replace: true });
    return true;
  }
  return false;
};

export default API_BASE_URL;
